<template>
    <Dropdown class="c-ex-dropdown" trigger="click">
        <slot></slot>
        <DropdownMenu slot="list" placement="bottom" class="c-ex-dropdown">
            <div class="dropdown-tool">
                <Input class="dropdown-search" v-model="keyword" :placeholder="placeholder"/>
                <a @click="changeFilterList(false)" class="blue-btn">清除</a>
                <a @click="changeFilterList(true)" class="blue-btn">全选</a>
                <slot name="function-btn"></slot>
            </div>
            <div class="campaign-dropdown-item title">
                <p class="campaign-dropdown-item-left showregular">
                    <span>{{leftName}}</span>
                    <span class="showregular">{{rightName}}</span>
                </p>
            </div>
            <div hidden>{{returnString}}</div>
            <div
                @click="item.selected=!item.selected"
                class="campaign-dropdown-item"
                :class="{active:item.selected}"
                v-for="item in filterList"
                :key="item[code]"
            >
                <p class="campaign-dropdown-item-left showregular">
                    <span>{{item[left]}}</span>
                    <span class="showregular">{{item[right]}}</span>
                </p>
                <div class="campaign-dropdown-item-right">
                    <i class="icon icon-checkbox" :class="{active:item.selected}"></i>
                </div>
            </div>
        </DropdownMenu>
    </Dropdown>
</template>
<script>
/**
 * @desc 通用Ex下拉多选
 *       请在sourceList初始化后再渲染该组件，防止多次应用sourceList产生数据污染
 * @param {String} value 双向绑定的值，暂只支持逗号分隔字符串
 * @param {Array} sourceList 源选项列表
 * @param {String} code 输出的字段值
 * @param {String} left 左边的文字
 * @param {String} leftName 表头
 * @param {String} right 右边的文字
 * @param {String} rightName 表头
 * @param {String} placeholder 搜索框显示的提示
 */
export default {
    name: 'cDropdown',
    props: {
        value: {
            type: String,
        },
        sourceList: {
            type: Array,
            default: () => [],
        },
        code: {
            type: String,
        },
        left: {
            type: String,
        },
        leftName: {
            type: String,
        },
        right: {
            type: String,
        },
        rightName: {
            type: String,
        },
        placeholder: {
            type: String,
            default: '请输入关键字',
        },
    },
    data() {
        return {
            keyword: '', //筛选关键字
            list: [], //复制的选项列表
        };
    },
    computed: {
        //关键字过滤后的列表
        filterList() {
            return this.list.filter(item => {
                const keyword = this.keyword.toUpperCase().trim(),
                    left = `${item[this.left]}`.toUpperCase(),
                    right = `${item[this.right]}`.toUpperCase();
                return left.includes(keyword) || right.includes(keyword);
            });
        },
        //已选择的数量
        selectedCount() {
            const count = this.list.filter(item => item.selected).length;
            this.$emit('changeCount', count);
            return count;
        },
        //是否全选
        selectedAll() {
            return this.list.length ? this.list.every(item => item.selected) : false;
        },
        //返回的字符串
        returnString() {
            let value = '';
            if (this.selectedCount) {
                value = this.list
                    .filter(item => item.selected)
                    .map(item => item[this.code])
                    .join(',');
            }
            this.$emit('input', value);
            return value;
        },
    },
    watch: {
        sourceList: {
            handler: function(newValue) {
                //初始化selected状态
                this.list = newValue.map(item => ({ ...item }));
                this.keyword = '';
            },
            immediate: true,
        },
    },
    mounted() {},
    methods: {
        /**
         * @desc 修改当前所有推广的状态
         * @param {Boolean} bool 要修改成的状态
         */
        changeFilterList(bool) {
            this.filterList.forEach(item => (item.selected = bool));
        },
    },
};
</script>
<style lang="scss">
.c-ex-dropdown {
    .campaign-dropdown-item {
        display: flex;
        font-size: 0.12rem;
        line-height: 0.36rem;
        padding: 0 0.1rem;
        justify-content: space-between;
        align-items: center;
        &.active,
        &:hover {
            background: #f3f3f3;
        }
        &.title {
            position: relative;
            font-size: 0.14rem;
            margin-bottom: 0.1rem;
            &::before {
                content: ' ';
                height: 1px;
                position: absolute;
                bottom: -1px;
                left: 0.1rem;
                right: 0.1rem;
                background: #f0f0f0;
            }
            &:hover {
                background: white;
            }
        }
        .campaign-dropdown-item-left {
            display: flex;
            flex: 1 1 auto;
            & > span:nth-of-type(1) {
                flex: 0 0 0.8rem;
            }
        }
        .campaign-dropdown-item-right {
            flex: 0 0 0.4rem;
            display: flex;
            justify-content: flex-end;
            //勾选图标
        }
    }
}
</style>





// WEBPACK FOOTER //
// src/components/commons/cExDropdown.vue